<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationformfile.header' | translate }}</span>
        </h2>
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationformfile.formfile' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell">
              <div class="ir-form-group">
                <input type="hidden" class="ir-form-set" formControlName="value" />
                <div class="ir-line ir-select th-select" (click)="openFileSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      editForm.controls.value.value
                        ? ('plugins.installationformfile.' + editForm.controls.value.value | translate)
                        : ('plugins.installationformfile.select-file' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell">
              <h2>
                <span style="margin-left: 10px">{{ 'plugins.installationformfile.instruction' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big plugin-table-cell">
              <div class="ir-form-group">
                <textarea
                  id="text"
                  formControlName="instruction"
                  rows="3"
                  placeholder="{{ 'plugins.installationformfile.instruction' | translate }}"
                  class="ir-form-set"
                ></textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big plugin-table-cell"></td>
            <td class="margin-big plugin-table-cell th-plugin-line--value">
              <button
                type="button"
                *ngIf="editForm.controls.value.value"
                class="ir-btn th-btn-modal ir-btn--title ir-txt--right"
                (click)="download()"
              >
                <span>{{ 'plugins.installationformfile.download' | translate }}</span>
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectFileMenu($event)" (modalClosed)="onClose($event)" #formfileModal></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
